import { useApolloClient } from "@apollo/client";
import { validateUser } from "../../graphql/query";

export const useValidateUser = async () => {
  const client = useApolloClient();
  const token = localStorage.USER_TOKEN;

  if (token) {
    const auth = await validateUser(client);
    if (auth.errMsg) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};
